import { render, staticRenderFns } from "./activityCategory.vue?vue&type=template&id=dfda389a&scoped=true"
import script from "./activityCategory.vue?vue&type=script&lang=js"
export * from "./activityCategory.vue?vue&type=script&lang=js"
import style0 from "./activityCategory.vue?vue&type=style&index=0&id=dfda389a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfda389a",
  null
  
)

export default component.exports